var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07953 0.333008C0.599278 0.333008 0.209961 0.722326 0.209961 1.20257C0.209961 1.68282 0.599278 2.07214 1.07953 2.07214H2.62674C2.75334 2.07214 2.87674 2.11198 2.97945 2.18601C3.08215 2.26004 3.15896 2.36451 3.19899 2.48462L6.06593 11.0871C6.19325 11.469 6.20944 11.8803 6.11179 12.2708L5.87572 13.2168C5.52933 14.6024 6.60785 15.9852 8.03604 15.9852H18.4708C18.9511 15.9852 19.3404 15.5959 19.3404 15.1156C19.3404 14.6354 18.9511 14.2461 18.4708 14.2461H8.03604C7.69745 14.2461 7.48008 13.9682 7.5622 13.6397L7.74023 12.9287C7.77039 12.8082 7.83995 12.7013 7.93786 12.6248C8.03577 12.5484 8.15641 12.5069 8.28061 12.5069H17.6013C17.9757 12.5071 18.3082 12.2677 18.4267 11.9125L20.7449 4.95597C20.9327 4.39268 20.5133 3.811 19.9195 3.81127H5.90968C5.78308 3.81127 5.65968 3.77143 5.55697 3.6974C5.45426 3.62338 5.37745 3.51891 5.33741 3.3988L4.51363 0.927437C4.39514 0.572273 4.06263 0.332812 3.68822 0.333008H1.07953Z",
    fill: "#161E40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16648 16.8547C6.20598 16.8547 5.42735 17.6334 5.42735 18.5939C5.42735 19.5544 6.20598 20.333 7.16648 20.333C8.12697 20.333 8.90561 19.5544 8.90561 18.5939C8.90561 17.6334 8.12697 16.8547 7.16648 16.8547Z",
    fill: "#F4B644"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6013 16.8547C16.6408 16.8547 15.8621 17.6334 15.8621 18.5939C15.8621 19.5544 16.6408 20.333 17.6013 20.333C18.5617 20.333 19.3404 19.5544 19.3404 18.5939C19.3404 17.6334 18.5617 16.8547 17.6013 16.8547Z",
    fill: "#F4B644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV);
export default __webpack_public_path__ + "static/media/v.adfbb0f64c0795ad901f5b0cbd81277f.svg";
export { ForwardRef as ReactComponent };